import {useMutation} from "@tanstack/react-query";

import {restoreClientMutationOptions} from "./restore-client.mutation-options";

export function useRestoreClient() {
  return useMutation(restoreClientMutationOptions());
}
